module.exports = __webpack_public_path__ + "static/media/tom-ford-ombre-leather-big.211a93ca.png";